<template lang="pug">
nav.d-flex.flex-wrap.justify-end
  template(v-for="(route, i) in menu")
    v-btn.main-header-btn.font-weight-bold.px-1(
      :key="i",
      :to="route.path",
      color="secondary",
      exact-active-class="main-header-btn-active",
      text
    ) {{ route.name }}
    v-divider.my-2.mx-3.secondary.lighten-2(
      v-if="i + 1 !== menu.length",
      vertical
    )
</template>

<script>
export default {
  props: {
    menu: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style>
.main-header-btn {
  position: relative;
}
.main-header-btn-active::before {
  background-color: transparent !important;
}
.main-header-btn::after {
  content: "";
  display: block;
  background: var(--v-primary-base);
  height: 2px;
  position: absolute;
  bottom: -2px;
  left: 50%;
  width: 0%;
  transition: 0.5s;
  margin: 0px 5px;
}
.main-header-btn-active::after {
  left: 0px;
  width: calc(100% - 10px);
}
</style>
